<template>
  <div class="system-page" id="app" style="overflow-y: scroll;">
    <mt-header :title="'公务用车审批'">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div class="header" style="display: flex; align-items: center; padding: 0 0; background-color: #f5f5f5;position: sticky; top: 0">
      <div class="scrollable-content" id="scrollableContent" style="height: auto;">
        <div style="width: 24rem;">
          <table class="bo table ">
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">提单人员</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.userName}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">提单日期</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.applyTime}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 150px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">用车开始时间</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.startTime}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 150px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">用车结束时间</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.endTime}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">目的地</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.destination}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">乘车人数</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.procseeDays}}</div></td>
            </tr>
            <tr class="rile" >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">用车事由</label></td>
              <td colspan="7" style="width:160px;">
                <div style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  {{item.processDescribe}}
                </div></td>
            </tr>
            <tr class="rile">
              <td class="wi"><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">附件</label></td>
              <td colspan="7" style="width:160px;">
                <div v-if="attachments.length!=0"style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <div
                      v-for="(item, idx) in attachments"
                      :key="idx"
                      style="display: flex; align-items: center; margin-bottom: 5px;">
                    <span>{{ item.attachmentName }} <div class="nameusersub" @click.prevent="previewFile(item)">预览</div></span>
                  </div>

                </div>
                <div v-else  style="width:260px;margin-left: -262px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <div   style="display: flex; align-items: center; margin-bottom: 5px;margin-left: -40px">
                    <span>无文件</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="roleId==12">
              <td class="wi" style="width: 200px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">分管领导审批</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">
                  <input style="width: 250px;height: 28px;font-size: 20px;" v-model="item.isFgName" readonly label="分管领导审批" @click.prevent="isFgVisible = true"/>
              </div>
              </td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">审核状态</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">
                  <input style="width: 250px;height: 28px;font-size: 20px;" v-model="item.restatusName" readonly label="审核状态" @click.prevent="statusVisible = true"/>
                  <i class="mintui mintui-field-error" style="margin-left: -188px;" @click.prevent="statusVisible = true"></i>
              </div>
              </td>
            </tr>
            <tr v-if="item.nameuser!=null&&item.restatusName=='已批准'&&item.isRes==0">
              <td class="wi" style="width: 120px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">下个审核人员</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">{{item.nameuser}}</div></td>
            </tr>
<!--            <tr>-->
<!--              <td class="wi" style="width: 100px !important; vertical-align: top;">-->
<!--                <label style="margin-top: 10px; font-size: 20px; height: 20px; color: #6d9eeb">签字</label>-->
<!--              </td>-->
<!--              <td colspan="7" style="width:160px;">-->
<!--                <div style="display: flex; align-items: center; gap: 10px;">-->
<!--                  <input type="file" id="signUpload" accept="image/*" style="display: none;"-->
<!--                         @change="handleSignatureUpload">-->
<!--                  <button v-if="!signatureImage" type="button"-->
<!--                          class="signPicture"-->
<!--                          @click="triggerFileUpload">-->
<!--                    上传签字-->
<!--                  </button>-->
<!--                  <div v-if="signatureImage" style="position: relative;">-->
<!--                    <img :src="signatureImage" style="max-height: 50px; border: 1px solid #ddd;">-->
<!--                    <button type="button" style="position: absolute; top: -10px; right: -10px; background: red; color: white; border-radius: 50%; width: 20px; height: 20px; border: none;"-->
<!--                            @click="removeSignature">-->
<!--                      ×-->
<!--                    </button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
<!--            </tr>-->
            <tr class="rile" v-if="item.managerAdvice&&!isManage">
              <td class="wi" style="width: 200px;" ><label style="margin-top: 10px;font-size:20px;line-height:20px;height: 20px;width: 160px;color: #6d9eeb">部门负责人({{item.managerName}})意见</label></td>
              <td colspan="7" style="width:360px;">
                <div style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <img v-if="item.managerSignPicture" :src="managerSignPicture" style="max-height: 50px; border: 1px solid #ddd;width:100px">{{item.managerAdvice}}
                </div></td>
            </tr>
            <tr class="rile" v-if="item.managerTime&&!isManage">
              <td colspan="7" >
                <div style="width:380px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;">
                  <div  style="margin-left: 180px">
                    {{item.managerTime}}
                  </div>
                </div>
              </td>
            </tr>
            <tr class="rile" v-if="item.officeAdvice&&proleId!=12">
              <td class="wi" style="width: 200px;" ><label style="margin-top: 10px;font-size:20px;line-height:20px;height: 20px;width: 160px;color: #6d9eeb">办公室({{item.officeName}})意见</label></td>
              <td colspan="7" style="width:360px;">
                <div style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <img v-if="item.officeSignPicture" :src="officeSignPicture" style="max-height: 50px; border: 1px solid #ddd;width:100px">{{item.officeAdvice}}
                </div></td>
            </tr>
            <tr class="rile" v-if="item.officeTime&&proleId!=12">
              <td colspan="7" >
                <div style="width:380px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;">
                  <div  style="margin-left: 180px">
                    {{item.officeTime}}
                  </div>
                </div>
              </td>
            </tr>
            <tr class="rile" v-if="item.resAdvice&&item.isRes==0">
              <td class="wi" style="width: 200px;" ><label style="margin-top: 10px;font-size:20px;line-height:20px;height: 20px;width: 160px;color: #6d9eeb">分管领导({{item.fgldName}})意见</label></td>
              <td colspan="7" style="width:360px;">
                <div style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <img v-if="item.resSignPicture" :src="resSignPicture" style="max-height: 50px; border: 1px solid #ddd;width:100px">{{item.resAdvice}}
                </div></td>
            </tr>
            <tr class="rile" v-if="item.resTime&&item.isRes==0">
              <td colspan="7" >
                <div style="width:380px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;">
                  <div  style="margin-left: 180px">
                    {{item.resTime}}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">审核意见</label></td>
              <td colspan="7" style="width:160px;">
                <div>
                  <input style="width: 250px;height: 28px;font-size: 20px;" v-model="item.advice" label="审核意见" />
                </div>
              </td>
            </tr>
          </table>
          <div v-if="item.restatusName=='未通过'||item.isRes==1">
            <div class="sub" @click.prevent="jieanSubmit":disabled="isSubmitting"> {{ isSubmitting ? '提交中...' : '审核并结案' }}</div>
          </div>
          <div v-else>
            <div v-if="item.nameuser!=null||(item.isRes==0&&this.userInfo.dept.deptId!=19)" class="sub" @click.prevent="liuzhuanSubmit":disabled="isSubmitting"> {{ isSubmitting ? '提交中...' : '审核并流转' }}</div>
            <div v-else class="sub" @click.prevent="jieanSubmit":disabled="isSubmitting"> {{ isSubmitting ? '提交中...' : '审核并结案' }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 审核状态选择 -->
    <mt-popup
        style="width: 100%"
        v-model="statusVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header>
        <mt-button @click.native="statusVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectStatusPicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-picker
          :slots="statusList"
          ref="statusList"
          valueKey="name"
      ></mt-picker>
    </mt-popup>
    <!-- 是否需要分管领导审批选择 -->
    <mt-popup
        style="width: 100%"
        v-model="isFgVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header>
        <mt-button @click.native="isFgVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectIsFgPicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-picker
          :slots="isFgList"
          ref="isFgList"
          valueKey="name"
      ></mt-picker>
    </mt-popup>
  </div>
</template>

<script>
import tabModule from "@/components/footerBar/index.vue";
import { getLocalData } from "@/utils/sessionData.js";
import request from "@/utils/keyCloakRequest";
import { resolveAppIsManage, syncAppReviewerNames } from "@/utils/appProcessManager";
import axios from "axios";
import {Indicator, Toast} from "mint-ui";
export default {
  components: {
    "v-tab-module": tabModule,
  },
  beforeMount() {},
  data() {
    return {
      managerSignPicture:'',
      officeSignPicture:'',
      resSignPicture:'',
      filePath:'',
      signatureImage: null,
      proleId:'',
      roleId: JSON.parse(getLocalData("userInfo")).role.roleId,
      statusList:[
        {
          values: [
            {
              code: "25",
              name: "已批准"
            },
            {
              code: "26",
              name: "未通过"
            }
          ],
          className: "slot1"
        }
      ],
      isFgList:[
        {
          values: [
            {
              code: "0",
              name: "是"
            },
            {
              code: "1",
              name: "否"
            }
          ],
          className: "slot1"
        }
      ],
      isFgVisible: false,
      statusVisible: false,
      reviewedId:'',
      item:{},
      route:'',
      userInfo: {},
      isLoading: false,
      attachments:[],
      isManage:false,
      isSubmitting: false,
    };
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.reviewedId = this.$route.query.item.reviewedId;
    axios({
      url: process.env.VUE_APP_SSO_URL+"appOfficialVehiclesShenDetail?reviewedId="+this.reviewedId,
      method: "get",
    }).then(  response => {
      this.item = response.data
      this.item.reviewedId = this.reviewedId
      this.item.statusId = 25
      this.item.restatusName='已批准'//前端使用后端不处理
      this.item.isFgName='是'//前端使用后端不处理
      this.allLoaded = true;
      if(this.item.proFileid!=""){
          request({
            url: "appDocumentFile?fileIds="+this.item.proFileid,
            method: "get"
          }).then(  response => {
            this.attachments = response
          })
      }
      syncAppReviewerNames(this, this.item)
      resolveAppIsManage(this, this.item, this.item.processId || this.processId)
      request({
        url: "appFindRoleId?userId="+this.item.userId,
        method: "get"
      }).then(  response => {
        this.proleId = response
      })
      Indicator.close();
    })

    this.route =  this.$route.query.route
  },
  mounted() {
  },

  methods: {
    async handleSignatureUpload(e) {
      const file = e.target.files;
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        this.signatureImage = event.target.result;
      };
      reader.readAsDataURL(file[0]);
      this.filePath = file[0]
      await axios({
        url: process.env.VUE_APP_SSO_URL+"appUploadSignPicture",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {filePath:this.filePath}
      }).then(res => {
        this.item.signPicture = res.data
      })
    },
    triggerFileUpload() {
      document.getElementById('signUpload').click();
    },
    removeSignature() {
      this.signatureImage = null;
      document.getElementById('signUpload').value = '';
    },
    previewFile(attachment){
      this.$router.push({
        name: 'filePreview',
        query: {
          attachment: attachment,
          item: this.item,
          route:this.route,
          name:'shenOfficialVehiclesDetail'
        },
      });
    },
    liuzhuanSubmit(){
      if (!this.item.advice) {
        Toast({
          message: "请填写审核意见"
        });
        return;
      }
      this.isSubmitting = true;
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOfficialVehiclesliuzhuan",
        method: "POST",
        data:this.item
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "审批成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    jieanSubmit(){
      if (!this.item.advice) {
        Toast({
          message: "请填写审核意见"
        });
        return;
      }
      this.isSubmitting = true;
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOfficialVehiclesjiean",
        method: "POST",
        data:this.item
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "审批成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    selectStatusPicker() {
      this.item.statusId = this.$refs.statusList.getValues()[0].code;
      this.item.restatusName =  this.$refs.statusList.getValues()[0].name;
      this.statusVisible = false;
    },
    selectIsFgPicker(){
      this.item.isRes = this.$refs.isFgList.getValues()[0].code;
      this.item.isFgName =  this.$refs.isFgList.getValues()[0].name;
      this.isFgVisible = false;
    },
    goBack() {
      this.$router.push(this.route);
    },
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 0.6rem;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}

body {
  display: block;
  margin: 0rem !important;
}
.nameusersub{
  width: 40%;
  height: 100px;
  line-height: 100px;
  background: #5cb85c;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.signPicture{
  width: 35%;
  height: 120px;
  line-height: 100px;
  font-size: 75px;
  background: green;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
}
.sub[disabled] {
  opacity: 0.6;
  width: 80%;
  height: 200px;
  line-height: 200px;
  font-size: 75px;
  background: #5f9cf5;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  color: #e5f4f9;
  margin-top: 100px;
  margin-left: 50px;
  cursor: not-allowed;
}
.sub {
  width: 80%;
  height: 200px;
  line-height: 200px;
  font-size: 75px;
  background: #5f9cf5;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
  margin-top: 100px;
  margin-left: 50px;
}
.menuTitle {
  font-size: 1rem;
}
.system-page {
  width: 100%;
  height: 100vh;
  background-color: #f1f5f8;
  font-family: "PingFangSC-Regular";
}
/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
</style>
